import React from 'react';
import Icon from '../../../components/AppIcon';

const BookingStatusCard = ({ booking, onViewDetails }) => {
  const getStatusConfig = (status) => {
    const configs = {
      confirmed: {
        color: 'text-success',
        bgColor: 'bg-success/10',
        icon: 'CheckCircle',
        label: 'Confirmed'
      },
      pending: {
        color: 'text-warning',
        bgColor: 'bg-warning/10',
        icon: 'Clock',
        label: 'Pending'
      },
      processing: {
        color: 'text-secondary',
        bgColor: 'bg-secondary/10',
        icon: 'Loader2',
        label: 'Processing'
      },
      completed: {
        color: 'text-primary',
        bgColor: 'bg-primary/10',
        icon: 'CheckCircle2',
        label: 'Completed'
      },
      cancelled: {
        color: 'text-error',
        bgColor: 'bg-error/10',
        icon: 'XCircle',
        label: 'Cancelled'
      }
    };
    return configs[status] || configs.pending;
  };

  const statusConfig = getStatusConfig(booking.status);

  return (
    <div 
      className="bg-card rounded-lg border border-border p-4 hover:shadow-medium transition-shadow cursor-pointer"
      onClick={() => onViewDetails(booking.id)}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <h4 className="font-heading font-semibold text-foreground mb-1">
            {booking.destination}
          </h4>
          <p className="text-sm text-muted-foreground">
            Booking ID: {booking.bookingId}
          </p>
        </div>
        <div className={`flex items-center space-x-1 px-2 py-1 rounded-full ${statusConfig.bgColor}`}>
          <Icon 
            name={statusConfig.icon} 
            size={14} 
            className={`${statusConfig.color} ${booking.status === 'processing' ? 'animate-spin' : ''}`}
          />
          <span className={`text-xs font-medium ${statusConfig.color}`}>
            {statusConfig.label}
          </span>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-3">
        <div>
          <p className="text-xs text-muted-foreground mb-1">Travel Date</p>
          <p className="text-sm font-medium text-foreground">
            {new Date(booking.travelDate).toLocaleDateString('en-IN', {
              day: '2-digit',
              month: 'short'
            })}
          </p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground mb-1">Amount</p>
          <p className="text-sm font-medium text-foreground">
            ₹{booking.amount.toLocaleString('en-IN')}
          </p>
        </div>
      </div>

      {booking.progress && (
        <div className="mb-3">
          <div className="flex justify-between items-center mb-1">
            <span className="text-xs text-muted-foreground">Progress</span>
            <span className="text-xs font-medium text-foreground">{booking.progress}%</span>
          </div>
          <div className="w-full bg-muted rounded-full h-2">
            <div 
              className="bg-primary h-2 rounded-full transition-all duration-300"
              style={{ width: `${booking.progress}%` }}
            />
          </div>
        </div>
      )}

      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <Icon name="Calendar" size={14} className="text-muted-foreground" />
          <span className="text-xs text-muted-foreground">
            Booked on {new Date(booking.bookingDate).toLocaleDateString('en-IN')}
          </span>
        </div>
        <Icon name="ChevronRight" size={16} className="text-muted-foreground" />
      </div>
    </div>
  );
};

export default BookingStatusCard;